import React from 'react';

const UserContext = React.createContext({ user: null });

export default UserContext;
